import type { IOrganizationFeaturePartnerPortal } from './OrganizationFeaturePartnerPortal.interface';
import OrganizationFeaturePartnerPortalNotifications from './OrganizationFeaturePartnerPortalNotifications';
import OrganizationFeaturePartnerPortalPermissions from './OrganizationFeaturePartnerPortalPermissions';

export default class OrganizationFeaturePartnerPortal
  implements IOrganizationFeaturePartnerPortal {
  permissions: OrganizationFeaturePartnerPortalPermissions;
  notifications: OrganizationFeaturePartnerPortalNotifications;

  static build = (data: IOrganizationFeaturePartnerPortal) =>
    new OrganizationFeaturePartnerPortal(data);
  static blank = () => new OrganizationFeaturePartnerPortal();

  /**
   * Constructor
   * @param {IOrganizationFeaturePartnerPortal} data
   */
  constructor(data?: IOrganizationFeaturePartnerPortal) {
    this.permissions = new OrganizationFeaturePartnerPortalPermissions(data?.permissions);
    this.notifications = new OrganizationFeaturePartnerPortalNotifications(data?.notifications);
  }
}
